import React from "react";
import classNames from "classnames";
import intl from "react-intl-universal";

import {Tooltip} from "../../../../components/Tooltip/Tooltip";


import "./NotificationCardBadge.css";


type NotificationCardBadgeSize = 16 | 20 | 24;

interface NotificationCardBadgeProps {
    isRead?: boolean;
    size?: NotificationCardBadgeSize;
    onClick?: () => void;
}

const sizeClassMap: Record<NotificationCardBadgeSize, string> = {
    16: "NotificationCardBadge--size-16",
    20: "NotificationCardBadge--size-20",
    24: "NotificationCardBadge--size-24",
};

export const NotificationCardBadge = ({
    isRead,
    size = 16,
    onClick,
}: NotificationCardBadgeProps) => {
    return (
        <Tooltip title={isRead
            ? intl.get('notification.card.badge.unread').d('Mark as unread')
            : intl.get('notification.card.badge.read').d('Mark as read')}
        >
            <span
                aria-hidden="true"
                onClick={onClick}
                className={classNames("NotificationCardBadge", {
                    "NotificationCardBadge--read": isRead,
                    "NotificationCardBadge--unread": !isRead,
                    "NotificationCardBadge--clickable": Boolean(onClick),
                }, sizeClassMap[size])}
            />
        </Tooltip>
    );
};
